var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLastPage = function SvgLastPage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 4.96v14.08a.77.77 0 0 1-.095.367.987.987 0 0 1-.271.312 1.32 1.32 0 0 1-.406.208 1.582 1.582 0 0 1-.956 0 1.326 1.326 0 0 1-.406-.208.989.989 0 0 1-.27-.312.772.772 0 0 1-.096-.367V4.96c0-.254.132-.499.366-.679.235-.18.553-.281.884-.281.331 0 .65.101.884.281.234.18.366.425.366.68zm-4.635 7.674a1.537 1.537 0 0 0-.388-1.791l-7.45-6.554a1.234 1.234 0 0 0-1.63 1.853l6.517 5.732a.169.169 0 0 1 .057.126.168.168 0 0 1-.057.126l-6.516 5.732a1.234 1.234 0 0 0 1.63 1.853l7.452-6.556c.163-.144.295-.322.385-.521z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLastPage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "last-page.040abf2bbeec2be4a4998d46eb48f5d9.svg";